import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { TimePickerService } from 'src/app/services/utils/time-picker/time-picker.service';
import { DatafieldsEnum } from '../datafield.enum';
import { IDatafieldComponent } from '../datafield.interface';

@Component({
  selector: 'app-datafield-hour',
  templateUrl: './datafield-hour.component.html',
  styleUrls: ['./datafield-hour.component.scss']
})
export class DatafieldHourComponent implements OnInit, OnDestroy, IDatafieldComponent {

  label: string
  session: string
  value: any
  datafield: Datafield
  formControl: FormControl = this.formBuilder.control(this.timepickerService.time00InTimePickerFormat, [Validators.required])
  formControlSubmitted: boolean = false
  subscriptionManager: Subscription = new Subscription()

  constructor(
    private datasheetService: DatasheetService,
    private formBuilder: FormBuilder,
    private timepickerService: TimePickerService,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    if (this.value) {
      this.formControl.setValue(this.timepickerService.formatStringToTimePicker(this.value))
    }
    this.subscriptionManager.add(this.datasheetService.datafieldValidationSubject
      .pipe(tap(() => {
        this.formControlSubmitted = true
        if (this.formControl.invalid) {
          this.datasheetService.everythingIsValid = false
          return
        }
        this.formControlSubmitted = false
      })).subscribe())
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.HOUR, this.label, this.formControl.value)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }
}
